import { render, staticRenderFns } from "./sign-header.vue?vue&type=template&id=8e57178c&"
import script from "./sign-header.vue?vue&type=script&lang=ts&"
export * from "./sign-header.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports